var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUtlNkningWhite = function SvgUtlNkningWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Lager_1",
    x: 0,
    y: 0,
    viewBox: "0 0 18 19"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 12.7c-.6 0-1.1.5-1.1 1.2v2.7H2.3V6.4h2.5c.6 0 1.1-.5 1.1-1.2S5.4 4 4.7 4H1.1C.5 4 0 4.5 0 5.2v12.6c0 .7.5 1.2 1.1 1.2h11.7c.6 0 1.1-.5 1.1-1.2v-3.9c.1-.6-.4-1.2-1-1.2",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9.8s0-.1-.1-.1c0-.1-.1-.2-.2-.3 0 0 0-.1-.1-.1-.1-.1-.2-.2-.3-.2 0-.1-.2-.1-.3-.1h-6.5c-.7 0-1.2.6-1.2 1.2 0 .7.5 1.3 1.2 1.3h3.7l-7.7 8.4c-.5.5-.5 1.3 0 1.8.2.2.5.3.8.3s.6-.1.8-.4l7.7-8.4v4c0 .7.5 1.2 1.2 1.2.6 0 1.2-.6 1.2-1.2v-7c-.1-.1-.1-.2-.2-.4",
    className: "st0"
  })));
};
export default SvgUtlNkningWhite;